<template>
    <v-footer
            v-if="!embedded"
            app
            inset>
        <span class="copyright">&copy; {{ copyright }}</span>
        <a 
                href="https://gappt.com/legal-atos" 
                target="_blank" 
                style="font-size: 11px;font-weight: 600;" 
                class="copyright align-center pl-1">Application Terms & Conditions & Privacy Policy</a>
    </v-footer>
</template>

<script>
    export default {
        name: "Footer",
        computed: {
            copyright() {
                return (
                    "2019-" +
                    new Date().getFullYear().toString() +
                    " Gapide Limited and its licensors. All rights reserved."
                );
            },
            embedded() {
                return this.$router.currentRoute.path.search('embedded') > -1
            }
        }
    }
</script>

<style scoped>
    .copyright {
        text-align: center;
        font-size: 10px;
    }
</style>